import PortletConstants from '~/zf/frontend/portlet/PortletConstants';
import ChartStatic from './chartStatic';
import VcomProvider from '../../VcomProvider';
import ChartStaticSettings from './ChartStaticSettings.vue';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const factory = (uniqueId) => new ChartStatic(uniqueId);
// note: need to use global VCOM object to get the same instance of VCOM as in "zf"
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
VCOM.PortletFactoryRegistry.register(PortletConstants.CHART_STATIC, factory);
const app = { component: ChartStaticSettings, options: {} };
VcomProvider.VueAppMounter.registerPortlet('chart-static-settings', app);
